import { AnalyticsService } from './../../services/analytics.service';
import { Component } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-bestwallet',
  templateUrl: './bestwallet.component.html',
  styleUrl: './bestwallet.component.scss',
})

export class BestwalletComponent {
  isBw = false;
  post_presale_singular_link: string = environment.post_presale_singular_link;

  constructor(public modalRef: BsModalRef, private analyticsService: AnalyticsService) {}

  handleSingularLinkClick(): void {
    this.analyticsService.vwoData('singular', { downloadBestwalletPlacement: 'Transaction success popup' });
  }
}
